import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import GET_CLASSROOM from 'graph/classroom/get-classroom-query';
import PageContainer from 'components/@layout/PageContainer';
import { Student } from 'types/schema-generated-types';
import PrintCertificate from './PrintCertificate';
import { usePageContentLoading } from 'providers/PageContentLoadingProvider';

interface ClassroomCertificatesContainerProps {
  classroomId: number;
  certificateType: string;
}
const sortStudents = (studentData: Student[]) => {
  let students = [...(studentData ?? [])];
  return students.sort((a: Student, b: Student) => {
    const result = a.firstName.localeCompare(b.firstName);
    return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
  });
};

const ClassroomCertificatesContainer: React.FC<ClassroomCertificatesContainerProps> = ({
  classroomId,
  certificateType
}) => {
  const { data, loading, error } = useQuery(GET_CLASSROOM, {
    variables: { id: classroomId }
  });
  const [{ registered }, { onElementLoaded, registerElements }] = usePageContentLoading();

  const handleOnLoad = (student: Student) => (): void => {
    onElementLoaded(String(student.id));
  };

  useEffect(() => {
    if (!registered && data?.classroom?.students) {
      registerElements(data?.classroom?.students.map((x: Student) => String(x.id)));
    }
  }, [data, registerElements, registered]);

  return (
    <PageContainer loading={loading} error={error}>
      <div>
        {sortStudents(data?.classroom?.students).map((student: Student) => (
          <PrintCertificate
            key={`print-certificate-${student.id}`}
            certificateType={certificateType}
            firstName={student.firstName}
            lastName={student.lastName}
            onLoad={handleOnLoad(student)}
          />
        ))}
      </div>
    </PageContainer>
  );
};

export default ClassroomCertificatesContainer;
